module.exports = __webpack_public_path__ + "img/Logo-18.a3171693.svg";